export default "__VITE_ASSET__BGe2xBx8__"